module.exports = __webpack_public_path__ + "static/img/200093.6cb9cd16.png";